<template>
	<div :class="'clickable-tile' + (disabled ? ' disabled' : '')" @click="toggleTileContent">
		<!-- <span v-if="action_items" class="badge">{{action_items}}</span> -->
		<div class="tile-front">
			<div class="icon">
				<i :class="'fa-solid fa-' + icon" style="padding-right: 10px"></i>
			</div>
			<!-- <p>{{ title }}</p> -->
		</div>
		<div class="tile-back">
			<p>{{ description + (year ? ' - ' + year : '') }}</p>
		</div>
		<div :class="'tile-footer' + (disabled ? ' disabled' : '')">
			<p>{{ title + (year ? ' - ' + year : '') }}</p>
		</div>
	</div>
</template>

<script>

export default {
	data: function () {
		return {
			//title: "test",
		};
	},
	props: {
		title: String,
		icon: String,
		description: String,
		footer_text: String,
		action_items: String,
		disabled: Boolean,
		year: String,
	},
	mounted: function () {
		//console.log("Title: " + this.title + " Icon: " + this.icon)
		// console.log("Displayong tje tile: " + this.title + " Icon: " + this.icon, " Description: " + this.description + " Footer: " + this.footer_text + " Action items: " + this.action_items, " year: " + this.year);
	},
	methods: {
		toggleTileContent() {
			if (!this.disabled) this.$emit('toggle-content');
		},
	},
};
</script>

<style scoped>
@media screen {
	.clickable-tile {
		box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
		text-align: center;
		/* padding: 10px; */
		padding-top: 10px;
		border: 1px solid #ccc;
		cursor: pointer;
		margin: 15px;
		/* Half of the desired spacing (30px / 2) */
		width: calc(33.3% - 30px);
		/* 3 columns with 30px spacing */
		max-width: 180px;
		min-width: 180px;
		min-height: 100px;
		display: inline-block;
		position: relative;
		perspective: 1000px;
		/* Depth of the 3D space for the flip effect */
	}

}

@media (max-width: 767px) {
	.clickable-tile {
		box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
		text-align: center;
		padding-top: 15px;
		border: 1px solid #ccc;
		cursor: pointer;
		margin: 7.5px;
		/* Half of the desired spacing (30px / 2) */
		min-width: calc(50% - 15px);
		/* 2 columns with 30px spacing */
		min-height: 100px;
		display: inline-block;
		position: relative;
		perspective: 1000px;
		/* Depth of the 3D space for the flip effect */
	}
}

.badge {
	position: absolute;
	top: 5px;
	/* Adjust the top position as needed */
	right: 5px;
	/* Adjust the right position as needed */
	background-color: rgb(240, 6, 6);
	/* Set the badge background color */
	color: #fff;
	/* Set the text color of the badge */
	border-radius: 50%;
	/* Make the badge circular */
	padding: 4px 8px;
	/* Adjust padding as needed */
	font-size: 12px;
	/* Adjust font size as needed */
}

.icon {
	font-size: 2rem;
	/* Adjust the size of the icon as needed */
	margin-bottom: 10px;
	/* Add spacing between the icon and text */
}

.tile-front,
.tile-back,
.tile-footer {
	width: 100%;
	position: absolute;
	transition: transform 0.5s;
	backface-visibility: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.tile-back {
	text-wrap: pretty;
}

.tile-footer {
	height: 25%;
}

.tile-footer {
	bottom: 0;
	/* Position the footer at the bottom */
	background-color: #d9d9d9;
	/* Add a background color to the footer */
	color: #000000;
	/* Set the text color of the footer */
	padding: 5px;
	/* Adjust the padding as needed */
	padding-top: 10%;
	font-weight: bold;
}

.tile-front {
	transform: rotateY(0deg);
}

.tile-back {
	transform: rotateY(180deg);
}

.clickable-tile:hover .tile-front {
	transform: rotateY(180deg);
}

.clickable-tile:hover .tile-back {
	transform: rotateY(0deg);
}

/* Deal with the 'disabled' look */
div.disabled {
	color: grey !important;
	cursor: default !important;
	opacity: 0.7 !important;
	box-shadow: none;
	pointer-events: none;
}
</style>